import React from 'react';
import { FormattedNumber } from 'react-intl';
import './ComponentToPrint.css';
import logo from 'logo.png';

interface Props {
  PageData?: any;
  Model?: any;
}

export const ComponentToPrint = React.forwardRef(
  ({ PageData, Model }: Props, ref: any) => {
    return (
      <div ref={ref}>
        <div id="container">
          <header>
            <img className="logo" src={logo} width="272" />
          </header>

          {PageData.Message}

          <h3>{PageData.PaymentPlanDetailsTabHeader}</h3>
          <table>
            <tbody>
              <tr>
                <td className="header bold">
                  {PageData.PlanDetailsCustomerNumberLabel}
                </td>
                <td className="value">
                  {Model.PlanDetails.PlanDetailsCustomerNumber}
                </td>
              </tr>
              <tr>
                <td className="header bold">
                  {PageData.PlanDetailsCurrentBalanceLabel}
                </td>
                <td className="value">
                  {typeof Model.PlanDetails.PlanDetailsCurrentBalance ===
                  'string' ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: Model.PlanDetails.PlanDetailsCurrentBalance,
                      }}
                    />
                  ) : (
                    <FormattedNumber
                      value={Model.PlanDetails.PlanDetailsCurrentBalance}
                      style="currency"
                      currency={Model?.currency}
                    />
                  )}
                </td>
              </tr>
              <tr>
                <td className="header bold">
                  {PageData.PlanDetailsNumberofInstallmentsLabel}
                </td>
                <td className="value">
                  {typeof Model.PlanDetails.PlanDetailsNumberofInstallments ===
                  'string' ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          Model.PlanDetails.PlanDetailsNumberofInstallments,
                      }}
                    />
                  ) : (
                    <FormattedNumber
                      value={Model.PlanDetails.PlanDetailsNumberofInstallments}
                      style="currency"
                      currency={Model?.currency}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <h3>{PageData.PaymentDetailsTabHeader}</h3>
          <table>
            <tbody>
              <tr>
                <td className="header">
                  {PageData.PlanDetailsPaymentMethodLabel}
                </td>
                <td className="value">
                  {Model.PlanDetails.PlanDetailsPaymentMethod}
                </td>
              </tr>
              {Model.PlanDetails.ExternalReference != null &&
                !Model.PlanDetails.ExternalReference && (
                  <tr>
                    <td className="header">
                      {PageData.ExternalPaymentReferenceNumber}
                    </td>
                    <td className="value">
                      {Model.PlanDetails.ExternalReference}
                    </td>
                  </tr>
                )}
              <tr>
                <td className="header">
                  {PageData.PlanDetailsPaymentDueDateLabel}
                </td>
                <td className="value">
                  {Model.PlanDetails.PlanDetailsFirstPaymentDueDate}
                </td>
              </tr>
              {Model.PlanDetails.PlanDetailsFinalPaymentAmount != null &&
                !Model.PlanDetails.PlanDetailsFinalPaymentAmount && (
                  <tr>
                    <td className="header bold">
                      {PageData.PlanDetailsFinalPaymentAmountLabel}
                    </td>
                    <td className="value">
                      {typeof Model.PlanDetails
                        .PlanDetailsFinalPaymentAmount === 'string' ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              Model.PlanDetails.PlanDetailsFinalPaymentAmount,
                          }}
                        />
                      ) : (
                        <FormattedNumber
                          value={
                            Model.PlanDetails.PlanDetailsFinalPaymentAmount
                          }
                          style="currency"
                          currency={Model?.currency}
                        />
                      )}
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>
    );
  },
);
